'use client';

import { FC, PropsWithChildren } from 'react';
import {
  useActiveControl,
  SubheaderPrimaryNav,
  HeaderMobileHamburgerMenu,
  useBreakpoint,
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';

export const HamburgerMenu: FC<PropsWithChildren> = ({ children }) => {
  const { isActive, toggle, close } = useActiveControl();
  const t = useTranslations();
  const text = t('MO_MORE_TITLE');
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);

  if (isDesktop && isActive) {
    close();
  }

  return (
    <>
      <HeaderMobileHamburgerMenu isActive={isActive} onClick={toggle} />
      <SubheaderPrimaryNav
        moreDropdownLabel={text}
        isCollapsed={isActive}
        style={{
          ['--cat-primary-nav-positon-top-mobile' as string]: '80px',
        }}
      >
        {children}
      </SubheaderPrimaryNav>
    </>
  );
};
